import { render, staticRenderFns } from "./analysis-referrals.vue?vue&type=template&id=138c8ea2&"
import script from "./analysis-referrals.vue?vue&type=script&lang=js&"
export * from "./analysis-referrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports